define([
	"dojo/_base/declare",
	"csi/view/ToolbarPluginMenu"
], function(declare,ToolbarPluginMenu) {

	return declare(ToolbarPluginMenu, {
		validatePlugin: function(/*Context*/ctx) {
			// summary: only allow for Style BOM
			var node = ctx.getContextNode();
			return node && node.$Type == "ApparelBOMRevision";
		}
	});
});